import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import {inventarioResources} from "../endpoints";

class DialogEnviarProductividad extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            title: props.title,
            id_jornada: "",
            rowData: props.rowData,
            enviando: false,
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    enviarDatosGestion = ()=> {
        let folio = this.state.rowData.folio
        this.setState({enviando:true})
        inventarioResources.enviarDatosProductividad(folio, this.state.id_jornada).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if (result.message) {
                this.props.refrescar(result.message,result.severity, folio)
            } else {
                throw new Error('Something went wrong ...');
            }
        }).catch(error => {
            let result = {
                message: "Ha ocurrido un error inesperado",
                severity: "error",
                status_code: 400
            }
            this.props.refrescar(result.message, result.severity, folio)
            console.log(error)
        });

    }
    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Enviar datos de productividad a Gestión</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            N° de jornada: <TextField value={this.state.id_jornada} autoFocus={true} name="id_jornada" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.id_jornada || this.state.enviando} variant="contained" onClick={this.enviarDatosGestion} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
export default DialogEnviarProductividad;